import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { HeaderComponent } from './header/header.component';
import { MultiFileUploadComponent } from '../componentes/multi-file-upload/multi-file-upload.component';
import { FileUploadModule } from 'ng2-file-upload';
import { IonicModule } from '@ionic/angular';
import { FiltroComponent } from '../componentes/filtro/filtro.component';
import { NavmenuComponent } from './navmenu/navmenu.component';

@NgModule({
  declarations: [HeaderComponent, MultiFileUploadComponent, FiltroComponent, NavmenuComponent],
  exports: [HeaderComponent, MultiFileUploadComponent, FiltroComponent, NavmenuComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FileUploadModule,
    ReactiveFormsModule
  ],
  providers: [DatePipe]
})
export class UIModule { }
